// @flow
import React from 'react';
import Theme from './theme';
import styled from 'styled-components';

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const BreadcrumbWrapper = styled.span`
  display: inline-flex;
  align-self: center;

  svg {
    height: 0.5625rem;

    top: -0.0625rem;
    position: relative;
  }
`;

const Divider = () => (
  <BreadcrumbWrapper>
    <svg fill="none" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg">
      <path
        fill={Theme.default.dividerColor}
        d="M5.572 5.027c.17.17.17.446 0 .616L1.508 9.707a.435.435 0 1 1-.616-.615L4.65 5.335.892 1.578a.435.435 0 0 1 .616-.615l4.064 4.064Z"
      />
    </svg>
  </BreadcrumbWrapper>
);

export default Divider;
